import {
  useDistributorSpecialPriceQuery,
  UseDistributorSpecialPriceQueryParams,
} from "../queries/usedistributorSpecialPrice.query";
import { IPagination } from "../../../interfaces/IPagination";
import { TDistributorSpecialPrice } from "../types/distributorSpecialPrice.types";

type Response = {
  distributorProductSpecialPrices: TDistributorSpecialPrice[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useDistributorSpecialPrice = (
  opt: UseDistributorSpecialPriceQueryParams,
): Response => {
  const { data, isLoading } = useDistributorSpecialPriceQuery(opt);
  return {
    distributorProductSpecialPrices:
      data?.data?.distributorProductSpecialPrices || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
